/* Caluma — progressive enhancement. Shopify owns prices, stock, discounts and checkout. */
(() => {
  'use strict';
  const campaign = () => {
    const body=document.body;
    const start=Date.parse(body.dataset.launchStart), end=Date.parse(body.dataset.launchEnd);
    const active=body.dataset.launchEnabled==='true' && Number.isFinite(start) && Number.isFinite(end) && end>start && Date.now()>=start && Date.now()<end;
    return {active,start,end};
  };
  function paintCampaign(){
    const c=campaign();
    document.querySelectorAll('[data-launch-banner],[data-launch-strip]').forEach(el=>el.hidden=!c.active);
    document.querySelectorAll('[data-regular-strip]').forEach(el=>el.hidden=c.active);
    if(c.active){const sec=Math.max(0,Math.floor((c.end-Date.now())/1000));const d=Math.floor(sec/86400),h=Math.floor(sec%86400/3600),m=Math.floor(sec%3600/60),s=sec%60;
      document.querySelectorAll('[data-countdown]').forEach(el=>{el.textContent=`${d}d ${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;el.setAttribute('title','Final: '+new Date(c.end).toLocaleString('es-ES',{timeZone:'Europe/Madrid'})+' (Madrid)');});
    }
    if(window.__launchActive!==c.active){window.__launchActive=c.active;document.dispatchEvent(new Event('caluma:campaign'));}
  }
  paintCampaign();setInterval(paintCampaign,1000);
  document.addEventListener('click',e=>{const a=e.target.closest('[data-policy]');if(a){const dlg=document.getElementById('politica-'+a.dataset.policy);if(dlg){e.preventDefault();dlg.showModal();}}const close=e.target.closest('[data-policy-close]');if(close)close.closest('dialog').close();});
  document.querySelectorAll('.policy-dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
  const initialized = new WeakSet();
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat('es-ES', { style: 'currency', currency }).format(cents / 100);
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const utmKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id'];
  // URL propagation only: no cookies, localStorage or pre-consent attribution requests.
  function withUtm(path) {
    const url = new URL(path, location.origin);
    const incoming = new URL(location.href).searchParams;
    utmKeys.forEach(key => { if (incoming.has(key) && !url.searchParams.has(key)) url.searchParams.set(key, incoming.get(key)); });
    return url.pathname + url.search + url.hash;
  }
  function propagateLinks(scope = document) {
    scope.querySelectorAll('a[href]').forEach(a => {
      const raw = a.getAttribute('href');
      if (!raw || raw.startsWith('#')) return;
      try {
        const url = new URL(a.href, location.origin);
        if (url.origin === location.origin && !url.pathname.includes('/policies/')) a.href = withUtm(url.href);
      } catch (_) { /* leave special links untouched */ }
    });
  }
  async function cartApi(path, payload) {
    const options = { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' };
    if (payload) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
    const response = await fetch(rootPath() + path, options);
    let data;
    try { data = await response.json(); } catch (_) { throw new Error('No hemos podido confirmar el carrito. Revísalo antes de volver a intentarlo.'); }
    if (!response.ok) throw new Error(data.description || data.message || 'No se ha podido actualizar el carrito. Revisa la disponibilidad.');
    return data;
  }
  function initProduct(section) {
    if (initialized.has(section)) return;
    initialized.add(section);
    const abort = new AbortController(); section._cleanup = () => { abort.abort(); observer?.disconnect(); resize?.disconnect(); document.body.classList.remove('has-mobile-buy'); };
    const listen = (el, event, fn) => el?.addEventListener(event, fn, { signal: abort.signal });
    const slides = [...section.querySelectorAll('[data-slide]')];
    const thumbs = [...section.querySelectorAll('[data-thumb]')];
    let imageIndex = 0;
    const selectImage = n => {
      if (!slides.length) return;
      imageIndex = (n + slides.length) % slides.length;
      slides.forEach((slide,i) => slide.hidden = i !== imageIndex);
      thumbs.forEach((thumb,i) => thumb.setAttribute('aria-pressed', String(i === imageIndex)));
      section.querySelector('.gallery-index').textContent = `${imageIndex + 1} / ${slides.length}`;
    };
    selectImage(0);
    let touchStart = null;
    const stage = section.querySelector('.gallery-stage');
    listen(stage,'touchstart',e=>{const t=e.touches[0];touchStart={x:t.clientX,y:t.clientY};});
    listen(stage,'touchend',e=>{if(!touchStart)return;const t=e.changedTouches[0];const dx=t.clientX-touchStart.x,dy=t.clientY-touchStart.y;if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.3)selectImage(imageIndex+(dx<0?1:-1));touchStart=null;});
    thumbs.forEach((t,i) => listen(t,'click',() => selectImage(i)));
    listen(section.querySelector('.gallery-prev'),'click',() => selectImage(imageIndex-1));
    listen(section.querySelector('.gallery-next'),'click',() => selectImage(imageIndex+1));
    listen(section.querySelector('.gallery-thumbs'),'keydown', e => {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); selectImage(imageIndex + (e.key === 'ArrowRight' ? 1 : -1)); thumbs[imageIndex]?.focus(); }
    });
    const form = section.querySelector('#ProductForm');
    const sticky = section.querySelector('.mobile-buy');
    const purchase = section.querySelector('.purchase-block');
    const qty = form?.querySelector('[name=quantity]');
    const variantInput = form?.querySelector('[name=id]');
    let variants = []; try { variants = JSON.parse(section.querySelector('[data-variants]').textContent) || []; } catch (_) {}
    let current = variants.find(v => String(v.id) === variantInput?.value) || variants[0];
    const salesEnabled = document.body.dataset.salesEnabled === 'true';
    const bundle = section.dataset.bundle === 'true';
    const discount = Number(section.dataset.discount) || 0;
    const currency = section.dataset.currency;
    let busy = false;
    const canBuy = () => !!current?.available && salesEnabled;
    const totalPrice = quantity => Math.round(current.price*quantity*(bundle && campaign().active && quantity>=2?(100-discount)/100:1));
    function quantity() { return Number(qty?.value) || 1; }
    const setText = (sel,text) => section.querySelectorAll(sel).forEach(el => el.textContent = text);
    function update() {
      if (!current || !qty) return;
      const q = quantity();
      setText('[data-unit-price],[data-single-price]',money(current.price,currency));
      const launch=campaign().active, future=Number(document.body.dataset.futurePrice)||0;
      const compare=launch && future>current.price;
      section.querySelectorAll('[data-launch-copy]').forEach(el=>el.hidden=!compare);
      section.querySelectorAll('[data-regular-copy]').forEach(el=>el.hidden=compare);
      setText('[data-future-single]',money(future,currency));setText('[data-future-pair]',money(future*2,currency));
      setText('[data-launch-percent]',String(Math.floor((1-current.price/future)*100)));
      setText('[data-pair-percent]',String(Math.floor((1-totalPrice(2)/(future*2))*100)));
      setText('[data-launch-saving]',money(Math.max(0,future-current.price),currency));
      setText('[data-selection-saving]',money(Math.max(0,future*q-totalPrice(q)),currency));
      setText('[data-pack-extra]',launch?`${discount}% extra frente a dos sueltas`:'Dos unidades');
      const hasCompare=section.dataset.compareApproved==='true' && current.compare_at_price>current.price;
      section.querySelectorAll('[data-compare-price],[data-sale-badge]').forEach(el=>el.hidden=!hasCompare);
      setText('[data-compare-price]',money(current.compare_at_price || 0,currency));
      setText('[data-pair-original]',money(current.price*2,currency));
      setText('[data-total],[data-sticky-price]',money(totalPrice(q),currency));
      setText('[data-pair-unit]',money(totalPrice(2)/2,currency));
      setText('[data-pair-total]',money(totalPrice(2),currency));
      setText('[data-pair-saving]',money(current.price*2-totalPrice(2),currency));
      setText('[data-sticky-offer]',q>=2?`CALUMA · Pack de ${q}${campaign().active?' · −'+discount+'%':''}`:'CALUMA · 1 unidad');
      document.querySelectorAll('[data-final-price]').forEach(el => el.textContent=money(current.price,currency));
      form.querySelectorAll('[name=quantity_option]').forEach(r => r.checked=Number(r.value)===q);
      form.querySelector('.sale-actions').hidden=!canBuy();
      form.querySelector('.prelaunch-actions').hidden=canBuy();
      const notice=document.querySelector('[data-notify]');if(notice)notice.hidden=canBuy();
      form.querySelectorAll('button[name=add],[data-buy-now]').forEach(b => b.disabled=!canBuy() || busy);
      const label = section.querySelector('[data-sticky-action]'); if(label){label.textContent = canBuy() ? 'Añadir al carrito' : 'Ver disponibilidad';label.disabled=busy;}
      if (salesEnabled && !current.available) setText('[data-availability]','Ahora mismo no está disponible');
    }
    const jumpToNotice = () => {
      const notice = document.getElementById('aviso');
      if(notice){notice.scrollIntoView({behavior:'smooth',block:'center'});setTimeout(()=>notice.querySelector('input[type=email]')?.focus({preventScroll:true}),350);}
      else { purchase?.scrollIntoView({behavior:'smooth',block:'center'}); }
    };
    listen(document,'caluma:campaign',update);
    listen(qty,'input',update);
    listen(qty,'change',() => { if (!Number.isInteger(Number(qty.value)) || Number(qty.value) < 1) qty.value='1';update(); });
    form?.querySelectorAll('[data-step]').forEach(btn => listen(btn,'click',() => {qty.value=String(Math.max(1,Math.trunc(quantity())+Number(btn.dataset.step)));update();}));
    form?.querySelectorAll('[name=quantity_option]').forEach(r => listen(r,'change',() => {qty.value=r.value;update();}));
    listen(variantInput,'change',() => {
      current=variants.find(v => String(v.id)===variantInput.value);update();
      const url=new URL(location.href);url.searchParams.set('variant',variantInput.value);history.replaceState({},'',url);
      if(current?.featured_image?.src){const index=slides.findIndex(s=>s.querySelector('img')?.src.includes(current.featured_image.src.split('?')[0].split('/').pop()));if(index>=0)selectImage(index);}
    });
    function error(message) {
      const el=form?.querySelector('.form-error');if(!el)return;el.textContent=message;el.hidden=false;
      purchase.scrollIntoView({behavior:'smooth',block:'center'});
    }
    async function buy(checkout) {
      if(busy || !canBuy() || !form.reportValidity())return;
      const q=Number(qty.value);if(!Number.isInteger(q)||q<1){error('Elige una cantidad válida.');return;}
      busy=true;form.setAttribute('aria-busy','true');form.querySelector('.form-error').hidden=true;form.querySelector('.form-success').hidden=true;update();
      try {
        if(checkout){
          // Set the selected variant to the exact requested quantity; preserve unrelated products.
          const previous=await cartApi('cart.js');
          const matches=previous.items.filter(item=>String(item.variant_id)===String(current.id));
          if(matches.length){
            for(const duplicate of matches.slice(1))await cartApi('cart/change.js',{id:duplicate.key,quantity:0});
            await cartApi('cart/change.js',{id:matches[0].key,quantity:q});
          }else await cartApi('cart/add.js',{items:[{id:current.id,quantity:q}]});
        } else await cartApi('cart/add.js',{items:[{id:current.id,quantity:q}]});
        const cart=await cartApi('cart.js');
        document.querySelectorAll('.cart-count').forEach(el=>el.textContent=String(cart.item_count));
        // Never trust a display-only offer. Stop an accelerated transition if Shopify disagrees.
        if(q>=1){
          const lines=cart.items.filter(item=>String(item.variant_id)===String(current.id));
          const actualQty=lines.reduce((a,item)=>a+item.quantity,0);
          const actual=lines.reduce((a,item)=>a+item.final_line_price,0);
          if(actual !== totalPrice(actualQty)){error('El total del carrito ha cambiado. Revísalo antes de continuar al pago.');return;}
        }
        if(checkout){location.assign(withUtm(rootPath()+'checkout'));return;}
        form.querySelector('.form-success').hidden=false;
        window.CalumaOpenCart?.(cart);
        const toast=document.getElementById('cart-message');toast.textContent=q===1?'Añadido al carrito.':`${q} unidades añadidas al carrito.`;toast.hidden=false;setTimeout(()=>toast.hidden=true,4000);
      }catch(e){error(e.message || 'No se ha podido confirmar la operación. Revisa el carrito antes de reintentar.');}
      finally{busy=false;form.removeAttribute('aria-busy');update();}
    }
    listen(form,'submit',e=>{e.preventDefault();buy(false);});
    listen(section.querySelector('[data-buy-now]'),'click',()=>buy(true));
    listen(section.querySelector('[data-sticky-action]'),'click',()=>canBuy()?buy(false):jumpToNotice());
    let passed=false;
    const syncSticky=()=>{
      passed=!!purchase && purchase.getBoundingClientRect().bottom<0;
      const focused=document.activeElement;
      const editing=focused?.matches('input,select,textarea');
      const privacy=document.querySelector('#shopify-pc__banner');
      const privacyVisible=privacy && privacy.getBoundingClientRect().height>0;
      const show=!!form && section.getClientRects().length>0 && !editing && !privacyVisible;
      sticky.hidden=!show;document.body.classList.toggle('has-mobile-buy',show);
    };
    const observer=new IntersectionObserver(([entry])=>{passed=!entry.isIntersecting && entry.boundingClientRect.bottom<0;syncSticky();},{threshold:0});
    if(purchase)observer.observe(purchase);
    const resize=new ResizeObserver(syncSticky);resize.observe(document.body);
    let scrollQueued=false;
    window.addEventListener('scroll',()=>{if(!scrollQueued){scrollQueued=true;requestAnimationFrame(()=>{scrollQueued=false;syncSticky();});}},{passive:true,signal:abort.signal});
    listen(window,'resize',syncSticky);listen(document,'focusin',syncSticky);listen(document,'focusout',()=>setTimeout(syncSticky,0));
    listen(document,'visitorConsentCollected',syncSticky);
    update();
    syncSticky();
  }
  function init(scope=document){
    propagateLinks(scope);
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    scope.querySelectorAll('.load-reviews').forEach(btn=>{
      if(initialized.has(btn))return;initialized.add(btn);
      btn.addEventListener('click',()=>{const hidden=[...btn.closest('section').querySelectorAll('[data-more-review][hidden]')];hidden.slice(0,6).forEach(el=>el.hidden=false);if(hidden.length<=6)btn.hidden=true;});
    });
    const cartForm=scope.querySelector('#CartForm');if(cartForm)cartForm.action=withUtm(cartForm.action);
  }
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-product-section]').forEach(section=>section._cleanup?.()));
  init();
  const drawer=document.getElementById('CalumaCart');
  if(drawer){
    window.CalumaOpenCart=async function(provided){
      const status=drawer.querySelector('[data-cart-status]');
      if(!drawer.open)drawer.showModal();
      status.textContent='';
      try{
        const cart=provided || await cartApi('cart.js');
        const target=drawer.querySelector('[data-cart-content]');target.replaceChildren();
        for(const line of cart.items){
          const item=document.createElement('article');item.className='drawer-item';
          const img=document.createElement('img');img.src=line.image || document.querySelector('.gallery-slide img')?.src || '';img.alt='';img.width=68;img.height=88;
          const details=document.createElement('div'),title=document.createElement('h3'),qty=document.createElement('p'),price=document.createElement('strong');
          title.textContent=line.product_title || 'CALUMA · Bata-manta eléctrica';qty.textContent=`${line.quantity} ${line.quantity===1?'unidad':'unidades'} · ${line.variant_title==='Default Title'?'Gris':line.variant_title || 'Gris'}`;price.textContent=money(line.final_line_price,cart.currency || 'EUR');
          details.append(title,qty,price);item.append(img,details);target.append(item);
        }
        if(!cart.items.length)target.textContent='Tu carrito está vacío.';
        drawer.querySelector('[data-cart-total]').textContent=money(cart.total_price,cart.currency || 'EUR');
        drawer.querySelector('[data-cart-checkout]').hidden=cart.items.length===0;
        document.querySelectorAll('.cart-count').forEach(el=>el.textContent=cart.item_count);
      }catch(e){status.textContent='No se ha podido cargar el carrito. Puedes abrir el carrito completo.';}
    };
    drawer.querySelectorAll('[data-cart-close]').forEach(b=>b.addEventListener('click',()=>drawer.close()));
    drawer.addEventListener('click',e=>{if(e.target===drawer && e.clientX<drawer.getBoundingClientRect().left)drawer.close();});
    document.querySelectorAll('.cart-link').forEach(a=>a.addEventListener('click',e=>{e.preventDefault();window.CalumaOpenCart();}));
  }
})();

document.querySelectorAll('[data-review-carousel]').forEach(root=>{const slides=[...root.querySelectorAll('[data-review-slide]')];if(slides.length<2)return;let index=0,paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const button=root.querySelector('[data-review-pause]');function draw(){slides.forEach((s,i)=>s.hidden=i!==index);root.querySelector('[data-review-position]').textContent=(index+1)+' / '+slides.length;button.textContent=paused?'Reanudar':'Pausar';}root.querySelector('[data-review-next]').onclick=()=>{index=(index+1)%slides.length;draw()};root.querySelector('[data-review-prev]').onclick=()=>{index=(index+slides.length-1)%slides.length;draw()};button.onclick=()=>{paused=!paused;draw()};setInterval(()=>{if(!paused&&!root.matches(':hover')&&!root.contains(document.activeElement)){index=(index+1)%slides.length;draw()}},6500);draw()});
document.querySelectorAll('.video-rail video').forEach(video=>video.addEventListener('play',()=>document.querySelectorAll('.video-rail video').forEach(other=>{if(other!==video)other.pause();})));
document.querySelectorAll('.mobile-menu a').forEach(a=>a.addEventListener('click',()=>a.closest('details').removeAttribute('open')));
document.querySelectorAll('a[href="#garantia"]').forEach(a=>a.addEventListener('click',()=>document.getElementById('garantia')?.setAttribute('open','')));
